import {
  faFacebookF,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Link, scroller } from "react-scroll";
import Common_Btn from "../common/common-btn/Common_Btn";
import "./Header.css";
import { getAppSetup, getSocialLinks } from "../../utils/gymOwnerApi";

function Header() {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = useState("banner");

  const [appOptions, setAppOptions] = useState();
  const [socialLinks, setSocialLinks] = useState();

  const apiAppSetup = async () => {
    const response = await getAppSetup("customer");
    if (response.success && response.data) {
      setAppOptions(response.data);
    }
  };
  const apiSocialLinks = async () => {
    const response = await getSocialLinks("customer");
    if (response.success && response.data) {
      setSocialLinks(response.data);
    }
  };

  useEffect(() => {
    apiAppSetup()
    apiSocialLinks();
  }, []);

  const handleNavClick = (section) => {
    setExpanded(false);

    setActiveLink(section);

    if (location.pathname !== "/home") {
      navigate("/home");
      setTimeout(() => {
        scroller.scrollTo(section, {
          smooth: true,
          duration: 500,
          offset: -80,
        });
      }, 300);
    } else {
      scroller.scrollTo(section, {
        smooth: true,
        duration: 500,
        offset: -80,
      });
    }
  };



  const handleNavigate = (path) => {
    navigate(path);
    setExpanded(false);
  };

  const closeNavbar = () => setExpanded(false);
  const scrollProps = {
    spy: true,
    smooth: true,
    duration: 100,
    onClick: closeNavbar,
  };



  return (
    <section className="header_section">
      <Navbar
        expand="lg"
        className="bg-body-tertiary p-0"
        collapseOnSelect
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <div className="container-fluid p-0">
          {/* ================= DESKTOP VIEW ================= */}

          {/* Logo */}
          <div className="logo_holder">
            <Navbar.Brand as={Link} to="banner" {...scrollProps}>
              <img
                src="/Assets/images/header/gymify_logo.png"
                alt="Gymify"
                className="logo_image"
                onClick={() => navigate("/home")}
              />
            </Navbar.Brand>
          </div>
          <div className="right_container_holder">
            {/* Top strip */}
            <div className="strip_1">
              <div className="contact_info">
                <span>
                  <FontAwesomeIcon icon={faEnvelope} /> {appOptions?.[0]?.email || ""}
                </span>
                <span>
                  <FontAwesomeIcon icon={faPhone} /> {appOptions?.[0]?.contact_no || ""}
                </span>
              </div>

              <div className="icon_holder_div">

                {socialLinks && socialLinks?.map((data) => (
                  <div className="icon_holder">
                    <a
                      href={data?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >

                      <img
                        src={process.env.REACT_APP_IMG_URL + data?.icon}
                        className="icon-image"
                      ></img>
                      {/* <FontAwesomeIcon
                        icon={faFacebookF}
                        style={{ color: "#fff" }}
                      /> */}
                    </a>
                  </div>


                ))}
                {/* <div className="icon_holder">
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faFacebookF}
                      style={{ color: "#fff" }}
                    />
                  </a>
                </div>

                <div className="icon_holder">
                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faInstagram}
                      style={{ color: "#fff" }}
                    />
                  </a>
                </div>

                <div className="icon_holder">
                  <a
                    href="https://www.youtube.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faYoutube}
                      style={{ color: "#fff" }}
                    />
                  </a> 
              </div>*/}
              </div>
            </div>

            {/* Nav strip */}
            <div className="strip_2">
              <Navbar.Collapse id="main-navbar">
                <Nav>
                  <Nav.Link
                    className={activeLink === "banner" ? "active" : ""}
                    onClick={() => handleNavClick("banner")}
                  >
                    Home
                  </Nav.Link>

                  <Nav.Link
                    className={activeLink === "about_section" ? "active" : ""}
                    onClick={() => handleNavClick("about_section")}
                  >
                    About Us
                  </Nav.Link>

                  <Nav.Link
                    className={activeLink === "why_choose" ? "active" : ""}
                    onClick={() => handleNavClick("why_choose")}
                  >
                    Why Choose Us?
                  </Nav.Link>

                  <Nav.Link
                    className={activeLink === "contact_us" ? "active" : ""}
                    onClick={() => handleNavClick("contact_us")}
                  >
                    Contact Us
                  </Nav.Link>

                  <div className="link_holder">
                    <Nav.Link
                      className={
                        activeLink === "take-your-goal" ? "active" : ""
                      }
                      onClick={() => handleNavClick("take-your-goal")}
                    >
                      Register
                    </Nav.Link>
                  </div>

                  <div className="btn_link_holder">
                    <Common_Btn
                      btnText="Download App"
                      onClick={() =>
                        window.open("https://play.google.com/store/apps/details?id=com.gymify.customer", "_blank")
                      }
                    />
                  </div>
                </Nav>
              </Navbar.Collapse>
            </div>
          </div>

          {/* ================= MOBILE VIEW ================= */}
          <div className="d-lg-none w-100">
            {/* Mobile Header Row */}

            <div className="mobile_header">
              <Navbar.Brand as={NavLink} to="/home" onClick={closeNavbar}>
                <img
                  src="/Assets/images/header/gymify_logo.png"
                  alt="Gymify"
                  className="logo_image"
                />
              </Navbar.Brand>

              <Navbar.Toggle aria-controls="basic-navbar-nav" />
            </div>

            <Navbar.Collapse id="mobile-navbar">
              <div className="mobile_menu">
                <Nav className="mobile_nav">
                  <Nav.Link
                    className={activeLink === "banner" ? "active" : ""}
                    onClick={() => handleNavClick("banner")}
                  >
                    Home
                  </Nav.Link>

                  <Nav.Link
                    className={activeLink === "about_section" ? "active" : ""}
                    onClick={() => handleNavClick("about_section")}
                  >
                    About Us
                  </Nav.Link>

                  <Nav.Link
                    className={activeLink === "why_choose" ? "active" : ""}
                    onClick={() => handleNavClick("why_choose")}
                  >
                    Why Choose Us?
                  </Nav.Link>

                  <Nav.Link
                    className={activeLink === "contact_us" ? "active" : ""}
                    onClick={() => handleNavClick("contact_us")}
                  >
                    Contact Us
                  </Nav.Link>

                  <Nav.Link
                    className="register"
                    onClick={() => handleNavigate("/login-flow?role=member")}
                  >
                    User Register
                  </Nav.Link>

                  <Nav.Link
                    className="register"
                    onClick={() => handleNavigate("/login-flow?role=owner")}
                  >
                    Owner Register
                  </Nav.Link>

                  <div className="mobile_btn">
                    <Common_Btn
                      btnText="Download Now"
                      onClick={() =>
                        window.open("https://play.google.com", "_blank")
                      }
                    />
                  </div>
                </Nav>
              </div>
            </Navbar.Collapse>
          </div>
        </div>
      </Navbar>
    </section >
  );
}

export default Header;
